import { CardCss } from './card-css';

export class Card {
  id?: number;
  courseId?: number;
  userCourseId?: number;
  title?: string;
  summary?: string;
  description?: string;
  author?: string;
  url?: string;
  img?: string;
  sasToken?: string;
  footer?: string;
  cardCss?: CardCss;
  isCompleted?: boolean | null;
  status?: string | null;

  constructor(data: Card) {
    this.id = data.id;
    this.courseId = data.courseId;
    this.userCourseId = data.userCourseId;
    this.title = data.title || '';
    this.summary = data.summary || '';
    this.description = data.description || '';
    this.author = data.author || '';
    this.url = data.url || '';
    this.img = data.img || '';
    this.footer = data.footer || '';
    this.sasToken = data.sasToken;
    this.cardCss = data.cardCss || new CardCss();
    this.isCompleted = data.isCompleted !== undefined ? data.isCompleted : null;
    this.status = data.status || null;
  }
}
